'use client'

import { MoonIcon, SunIcon } from '@radix-ui/react-icons'
import { useRouter } from 'next/navigation'
import { useTheme } from 'next-themes'

import { Button } from '@/components/ui/button'
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar
} from '@/components/ui/sidebar'

export function NavAuthButtons() {
  const { state } = useSidebar()
  const router = useRouter()
  const { theme, setTheme } = useTheme()

  if (state === 'collapsed') {
    return (
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuButton
            size="lg"
            className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground justify-center"
            onClick={() => router.push('/signup')}
          >
            <div className="flex items-center justify-center w-full">
              <span className="text-sm font-medium">Sign up</span>
            </div>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    )
  }

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <div className="space-y-2">
          <Button 
            className="w-full" 
            onClick={() => router.push('/signup')}
          >
            Sign up
          </Button>
          <Button 
            variant="outline" 
            className="w-full" 
            onClick={() => router.push('/login')}
          >
            Login
          </Button>
          <Button 
            variant="ghost" 
            className="w-full" 
            onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
            aria-label={`Activate ${theme === 'dark' ? 'light' : 'dark'} mode`}
          >
            <SunIcon className="h-[1rem] w-[1rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
            <MoonIcon className="absolute h-[1rem] w-[1rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
          </Button>
        </div>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
